import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { HttpService } from 'src/app/service/http/http.service';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { MatStepper } from '@angular/material/stepper';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ShowImagePopupComponent } from 'src/app/shared/popups/show-image-popup/show-image-popup.component';
import { ChooseColorPopupComponent } from 'src/app/shared/popups/choose-color-popup/choose-color-popup.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';

@Component({
  selector: 'app-profile-management',
  templateUrl: './profile-management.component.html',
  styleUrls: ['./profile-management.component.scss'],
})
export class ProfileManagementComponent implements OnInit {

  companyInformationForm: FormGroup = new FormGroup({});
  formSubmitted: boolean = false;
  dashboardColorNameList: any = [];
  showAddPopup: boolean = false;
  showDetailsPopup: boolean = false;
  showListingPage: boolean = true;
  isEditModeactive: boolean = false;
  loggedInUserId:any;
  companyID:any;
  uploadedFileUrl: any = '';
  fileName: any = null;
  fileType: any = null;
  companyData:any=[];
  loggedInUserCompanyID:any;
  compStatus:any;
  modulesOfHRAdmin:any;
  buttonColorName:any;
  companyFiscalyear:any;
  constructor(private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute, private sharedService: SharedService,
    private loader: LoaderService,private encryptionService:EncryptionService) { }

  ngOnInit() {
    this.initilaizeCompanyForm();
   }
   ionViewWillEnter() {
    this.editLogoFlag=false;
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.showAddPopup = false;
    this.showDetailsPopup = true;
    this.isEditModeactive = false;
    this.showListingPage = true;
    this.formSubmitted = false;
    this.activatedroute.params.subscribe((params: any) => {
     if (params?.operation == 'Edit') {
        this.companyID = this.loggedInUserCompanyID
        // this.showAddPopup = true;
        // this.showDetailsPopup = false;
        // this.isEditModeactive = true;
        // this.showListingPage = false;
        // this.getCompanyDataByCompID();
      } else if (params?.operation == 'Show') {
        this.companyID = this.loggedInUserCompanyID
        this.showAddPopup = false;
        this.showDetailsPopup = true;
        this.isEditModeactive = false;
        this.showListingPage = false;
        this.getAllModulesList();
        this.getCompanyDataByCompID();
      }
    })
  }
  initilaizeCompanyForm() {
    this.companyInformationForm = this.fb.group({
      buttonColorName: ['', Validators.required],
      companyName: ['', Validators.required],
      contactNo: ['',[Validators.required,Validators.pattern(/^[0-9]{10}$/)]],
      emailOfHrAdmin: ['', Validators.required],
      firstnameOfHrAdmin: ['', Validators.required],
      fiscalYear: ['', Validators.required],
      id: [null],
      logo: ['', Validators.required],
      moduleNameColor: ['', Validators.required],
      lastnameOfHrAdmin: ['', Validators.required],
      subModuleButtonColor: ['', Validators.required],
    })
  }
  getAllModulesList() {
    this.httpService.callGetService(this.config.getAllModule).subscribe((response: any) => {
      this.modulesOfHRAdmin = [];
      response?.data?.modules.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          moduleName: ele.moduleName,
          isAccessGiven: false,
          iconLink: ele.iconLink
        }
        this.modulesOfHRAdmin.push(obj);
      });
    });
  }
  accessGivenModuleIDs:any=[];
  getCompanyDataByCompID() {
    this.loader.simpleLoaderWithDuration();
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.companyID).subscribe((data: any) => {
      this.loader.dismissLoader();
      this.companyData = [];
      this.companyData.push(data?.data);
      this.dashboardColorNameList = data?.data?.dashboardColorName;
      this.uploadedFileUrl = data?.data?.logo;

      sessionStorage.setItem('loggedInCompanyIndustryName',data?.data?.industry?.industryName);
      sessionStorage.setItem('loggedInCompanyIndustryID',data?.data?.industry?.id); 
      sessionStorage.setItem('loggedInUserCompanyName', data?.data?.companyName);
      sessionStorage.setItem('loggedInCompanyData',JSON.stringify(data?.data));
      sessionStorage.setItem('subModuleButtonColor',data?.data?.subModuleButtonColor);
      sessionStorage.setItem('buttonColorName',data?.data?.buttonColorName);
      sessionStorage.setItem('moduleNameColor',data?.data?.moduleNameColor);
      sessionStorage.setItem('companyLogo',data?.data?.logo);
      this.companyFiscalyear = this.encryptionService.encryptData(data?.data?.fiscalYear);
      sessionStorage.setItem('loggedInCompanyFiscalyear',this.companyFiscalyear);
      this.buttonColorName = sessionStorage.getItem('buttonColorName'); 
      setTimeout(() =>
        {
          data?.data?.modules?.forEach((selectedValue: { id: any; }) => {
            const item = this.modulesOfHRAdmin.find((value: { id: any; }) => value.id === selectedValue.id);
            if (item) {
              item.isAccessGiven = true;
            }
          });
        },
      1000);
      this.companyInformationForm.controls['id'].setValue(data?.data?.id);
      this.companyInformationForm.controls['buttonColorName'].setValue(data?.data?.buttonColorName);
      this.companyInformationForm.controls['companyName'].setValue(data?.data?.companyName);
      this.companyInformationForm.controls['contactNo'].setValue(data?.data?.contactNo);
      this.companyInformationForm.controls['emailOfHrAdmin'].setValue(data?.data?.emailOfHrAdmin);
      this.companyInformationForm.controls['fiscalYear'].setValue(data?.data?.fiscalYear);
      this.companyInformationForm.controls['logo'].setValue(data?.data?.logo);
      this.companyInformationForm.controls['moduleNameColor'].setValue(data?.data?.moduleNameColor);
      this.companyInformationForm.controls['firstnameOfHrAdmin'].setValue(data?.data?.firstnameOfHrAdmin);
      this.companyInformationForm.controls['lastnameOfHrAdmin'].setValue(data?.data?.lastnameOfHrAdmin);
      this.companyInformationForm.controls['subModuleButtonColor'].setValue(data?.data?.subModuleButtonColor);
    })
  }
  transform(value: string): string {
    switch (value) {
      case 'OnBoardingPending':
        return 'On-Boarding Pending';
      case 'Active':
        return 'Active';
      case 'Inactive':
        return 'Inactive';
      case 'Jan_Dec':
        return 'Jan-Dec';
      case 'Apr_Mar':
        return 'Apr-Mar';
      case 'July_Jun':
        return 'July-Jun';
      case 'Oct_Sep':
        return 'Oct-Sep';
      default:
        return value;
    }
  }
  updateProfile() {
    this.companyInformationForm.markAllAsTouched();
    this.formSubmitted = true;
    if (this.companyInformationForm.valid) {
      this.formSubmitted = false;
      const request = {
        "buttonColorName": this.companyInformationForm.value.buttonColorName,
        "companyName": this.companyInformationForm.value.companyName,
        "contactNo": this.companyInformationForm.value.contactNo,
        "dashboardColorName": this.dashboardColorNameList,
        "emailOfHrAdmin": this.companyInformationForm.value.emailOfHrAdmin,
        "firstnameOfHrAdmin": this.companyInformationForm.value.firstnameOfHrAdmin,
        "fiscalYear": this.companyInformationForm.value.fiscalYear,
        "id": this.companyInformationForm.value.id,
        "lastnameOfHrAdmin": this.companyInformationForm.value.lastnameOfHrAdmin,
        "logo": this.companyInformationForm.value.logo,
        "moduleNameColor": this.companyInformationForm.value.moduleNameColor,
        "subModuleButtonColor": this.companyInformationForm.value.subModuleButtonColor,
      }
      this.loader.simpleLoaderWithDuration();
      this.httpService.callPostService(this.config.updateCompanybyHr, request)
        .subscribe((data: any) => {
          if (data.success) {
            this.editLogoFlag=false;
            this.editContactFlag=false;
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.companyInformationForm.value.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              // this.backBtn();
              this.getCompanyDataByCompID()
            });
          } else {
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              // this.backBtn();
            });
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  backBtn(){
    this.router.navigate(['/home/hrportal/employeemaster']);
  }
  editCompany() {
    this.router.navigate(['/home/hrportal/profileManagement', { id: this.companyID, operation: 'Edit' }]);
  }
  showImg(image: any, name: any) {
    const successdialogRef = this.dialog.open(ShowImagePopupComponent, {
      disableClose: true,
      height: '35%',
      width: '50%',
      data: {
        img: image,
        name: name
      },
    });
  }
  uploadImage(event: any) {
    const fileName = event.target.files[0].name;
    const fileType = event.target.files[0].type;
    if (!event.target.files[0].name.includes('png') 
      && !event.target.files[0].name.includes('PNG') 
      && !event.target.files[0].name.includes('jpg') 
      && !event.target.files[0].name.includes('JPG') 
      && !event.target.files[0].name.includes('jpeg') 
      && !event.target.files[0].name.includes('JPEG')) {
       window.alert("File format is not supported");
       return;
     }
    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    const url = this.config.uploadFileLocally + `?fileName=${fileName}&fileType=${fileType}`
    this.loader.simpleLoader();
    this.httpService.submitFormService(url, formData).subscribe((res: any) => {
      this.fileName = event.target.files[0].name;
      this.fileType = event.target.files[0].type;
      this.uploadedFileUrl = res.data;
      this.companyInformationForm.controls['logo'].setValue(res.data);
      this.loader.dismissLoader();
      this.updateProfile();
    }, (error: any) => {
      this.loader.dismissLoader();
    })
  }
  onClickColorPalletPlushIcon() {
    const successdialogRef = this.dialog.open(ChooseColorPopupComponent, {
      disableClose: true,
      height: '35%',
      width: '50%',
      data: {
        moduleNameColor: this.companyInformationForm.value.moduleNameColor,
        subModuleButtonColor: this.companyInformationForm.value.subModuleButtonColor,
        buttonColorName: this.companyInformationForm.value.buttonColorName,
        selectedColor: this.dashboardColorNameList
      },
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.companyInformationForm.controls['moduleNameColor'].setValue(result?.moduleNameColor);
        this.companyInformationForm.controls['subModuleButtonColor'].setValue(result?.subModuleButtonColor);
        this.companyInformationForm.controls['buttonColorName'].setValue(result?.buttonColorName);
        this.dashboardColorNameList = result?.dashboardList
        this.updateProfile();
      }
    });
  }
  editLogoFlag: boolean=false;
  editContactFlag: boolean=false;
  editCustomColor(){
    this.onClickColorPalletPlushIcon()
  }
  editLogo(){
    this.editLogoFlag = true;
  }
  canelEditLogo(){
    this.editLogoFlag = false;
  }
  editContact(){
    this.editContactFlag = true;
  }
}
